import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/variants/initial-static-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/variants/variant-infinte-scroll.tsx");
